import styled from "styled-components";
import { responsive } from "../../../styles/constants.style";

export const ViewCompanyAddressWrapper = styled.div`
  margin: 16px 0;

  .container {
    width: 100%;
    margin: 24px 16px;
    ${responsive.MOBILE`
      margin: 16px 8px 16px 0;
    `}
  }
`;
